<template>
    <Spinner v-if="displaySpinner" />
    <Page>
        <template #title>
            <EditableTitle v-model="domainTerm" icon="pi pi-book" />
        </template>
        <template #controls>
            <LastChangedInfo
                v-if="domainTerm?.identity"
                :entityId="domainTerm.identity"
                :entityType="DOMAIN_TERM_ENTITY_TYPE"
            />
        </template>
        <Section editable>
            <TextAppArtefact
                v-if="domainTerm?.identity && description"
                v-model="description"
                :entityId="domainTerm.identity"
                :entityType="DOMAIN_TERM_ENTITY_TYPE"
                :isEditing="isEditing"
                :stekzModel="domainTerm"
                ref="textAppArtefact"
            />
        </Section>
    </Page>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";

import EditableTitle from "@/components/EditableTitle.vue";
import LastChangedInfo from "@/components/LastChangedInfo.vue";
import Page from "@/components/Page.vue";
import Section from "@/components/Section.vue";
import TextAppArtefact from "@/components/TextAppArtefact.vue";
import { useDomainTermManager } from "@/composables/domain-term-manager";
import { useEditManager } from "@/composables/edit-manager";
import Spinner from "@/shared/Spinner.vue";
import { EntityType } from "@/stores/entity-store";

const DOMAIN_TERM_ENTITY_TYPE = EntityType.DOMAIN_TERM;

const { isEditing } = useEditManager();
const { domainTerm, isFetching, description } = useDomainTermManager();

const displaySpinner = ref(false);
watch(isFetching, (v) => (displaySpinner.value = v), { immediate: true });
</script>
